/**
 * Dil değiştirme composable'ı.
 *
 * setLocale tek noktadan: vue-i18n mesajları, PrimeVue bileşen locale'i,
 * dayjs tarih locale'i ve <html lang> birlikte güncellenir.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePrimeVue } from 'primevue/config'
import {
  LOCALE_OPTIONS,
  isI18nEnabled,
  setLocale as applyLocale,
  type AppLocale,
} from '@/i18n'
import { getPrimeVueLocale } from '@/i18n/primevue-locales'

export function useLocale() {
  const { locale } = useI18n()
  const primevue = usePrimeVue()

  const currentLocale = computed<AppLocale>(() => locale.value as AppLocale)

  const currentOption = computed(
    () => LOCALE_OPTIONS.find((o) => o.value === currentLocale.value) ?? LOCALE_OPTIONS[0],
  )

  function setLocale(next: AppLocale) {
    if (next === currentLocale.value) return
    applyLocale(next)
    // PrimeVue bileşenlerinin (DatePicker vb.) locale'ini de güncelle
    Object.assign(primevue.config.locale as Record<string, unknown>, getPrimeVueLocale(next))
  }

  return {
    /** Dil seçicinin gösterilip gösterilmeyeceği (yurt dışı dağıtımı bayrağı). */
    isI18nEnabled,
    localeOptions: LOCALE_OPTIONS,
    currentLocale,
    currentOption,
    setLocale,
  }
}
